import { Workflow, Layers, Sparkles } from "lucide-react";
import SectionHeader from "@/components/SectionHeader";

const pillars = [
  {
    icon: Workflow,
    title: "Automatisierte Workflows",
    description:
      "Von Briefing über Skript-Iteration bis zur Farbkorrektur nutzen wir KI-gestützte Pipelines, die manuelle Wartezeiten eliminieren. Ergebnisse in Tagen statt Wochen.",
  },
  {
    icon: Layers,
    title: "Klare Systeme",
    description:
      "Produktion, Nachbereitung und Korrekturschleifen laufen in einem strukturierten Prozess. Sie wissen zu jedem Zeitpunkt, wo Ihr Projekt steht.",
  },
  {
    icon: Sparkles,
    title: "KI als Verstärker, nicht Ersatz",
    description:
      "Wir kombinieren echtes Film-Handwerk mit modernster KI. Das Ergebnis: Wirkung und Story auf Kinoniveau, produziert mit der Effizienz der Zukunft.",
  },
];

const AIFirstMethodology = () => {
  return (
    <section className="py-20 md:py-28 bg-background relative">
      <div className="container mx-auto px-4 md:px-6">
        <SectionHeader
          badge="AI-first Methodik"
          title="Modernste Technologie. Echtes Handwerk."
          highlightedWord="Technologie."
          description="Wir sind eine Agentur, die klassische Videoproduktion und KI beherrscht — und beides bewusst kombiniert."
          className="mb-14"
        />

        <div className="grid grid-cols-1 md:grid-cols-3 gap-4 md:gap-6 max-w-6xl mx-auto">
          {pillars.map((pillar) => (
            <div
              key={pillar.title}
              className="relative rounded-3xl border border-border bg-card p-6 md:p-8 md:hover:border-accent/40 transition-colors duration-300"
            >
              <div className="w-11 h-11 rounded-xl bg-accent/15 border border-accent/30 flex items-center justify-center mb-5">
                <pillar.icon className="w-5 h-5 text-accent" />
              </div>
              <h3 className="text-xl md:text-2xl font-normal tracking-tight mb-3 text-foreground">
                {pillar.title}
              </h3>
              <p className="text-sm md:text-base text-muted-foreground leading-relaxed">
                {pillar.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default AIFirstMethodology;
